import { z } from 'zod';
import { EntityIdSchema, IsoDateTimeSchema, PaginatedResponseSchema } from './common';

/**
 * Tipos de actor que pueden aparecer en el audit log.
 */
export const ActorTipoSchema = z.enum(['operador', 'usuario', 'sistema', 'publico']);
export type ActorTipo = z.infer<typeof ActorTipoSchema>;

/**
 * Evento individual del audit log (ver docs/00-compartido/esquemas-datos.md §10).
 * Tabla `audit_log`: append-only, no UPDATE/DELETE permitido en API.
 */
export const AuditEventSchema = z.object({
  id: EntityIdSchema,
  timestamp: IsoDateTimeSchema,
  actor_tipo: ActorTipoSchema,
  actor_id: EntityIdSchema.nullable(),
  accion: z.string(),
  recurso_tipo: z.string().nullable().optional(),
  recurso_id: z.string().nullable().optional(),
  metadata_json: z.string().nullable().optional(),
  ip: z.string().nullable().optional(),
  user_agent: z.string().nullable().optional(),
  cohorte_id: EntityIdSchema.nullable().optional(),
});
export type AuditEvent = z.infer<typeof AuditEventSchema>;

/**
 * Query string de GET /api/v1/audit.
 * Backend REQUIERE al menos un filtro (devuelve 400 si todos están vacíos).
 */
export const AuditListQuerySchema = z
  .object({
    desde: IsoDateTimeSchema.optional(),
    hasta: IsoDateTimeSchema.optional(),
    actor_tipo: ActorTipoSchema.optional(),
    actor_id: EntityIdSchema.optional(),
    accion: z.string().optional(),
  })
  .refine(
    (v) => v.desde || v.hasta || v.actor_tipo || v.actor_id || v.accion,
    { message: 'Debe indicar al menos un filtro (desde, hasta, actor_tipo, actor_id o accion)' },
  );
export type AuditListQuery = z.infer<typeof AuditListQuerySchema>;

/**
 * Response de GET /api/v1/audit.
 */
export const AuditListResponseSchema = PaginatedResponseSchema(AuditEventSchema);
export type AuditListResponse = z.infer<typeof AuditListResponseSchema>;